import { Switch, Form, Typography } from 'antd'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { ConfigCard } from './styles'

const FormItem = Form.Item
const Text = Typography.Text

const HasTermination = ({ initialHasTermination }) => {
	const [enabled, setEnabled] = useState(initialHasTermination ?? false)

	const handleChange = (checked) => {
		setEnabled(checked)
	}

	return (
		<ConfigCard
			title="Permitir Distrato"
			extra={
				<FormItem
					name="hasTermination"
					valuePropName="checked"
					initialValue={enabled}>
					<Switch checked={enabled} onChange={handleChange} />
				</FormItem>
			}>
			<Text>
				Quando esta opção estiver ativada, os usuários poderão fazer upload de
				um distrato para o documento.
			</Text>
		</ConfigCard>
	)
}

HasTermination.propTypes = {
	initialHasTermination: PropTypes.bool,
}

export default HasTermination
